import { combineReducers } from 'redux';
import home from '../modules/Home/reducer';


const appReducer = combineReducers({
  home,
});

// NOTE: reset reducers after sign out.
const rootReducer = (state, action) => (appReducer(state, action));

export default rootReducer;
